import React from "react";
import { Box, Button, Paper, Rating, Typography } from '@mui/material'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import profileImage from '../../images/profileImage.jpg'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { ArrowForwardIos, LocationOn } from "@mui/icons-material";
import { Link } from "react-router-dom";

const SimiliarCandidateCard = () => {
    return (
        <>
            <Paper
                sx={{
                    position: 'relative',
                    border: '1px solid',
                    borderColor: '#8BACF84D',
                    backgroundColor: '#F8FAFF',
                    borderRadius: '10px',
                    boxShadow: '0px 10px 47px 0px #3665D014',
                }}
            >
                <BookmarkBorderIcon
                    sx={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                    }}
                />
                <img
                    src={profileImage}
                    alt="Image"
                    className="similiarCandidateCard"
                />

                <Box
                    sx={{
                        padding: '20px 20px 0px',
                    }}>
                    <Typography className='subHeading1Bold' mt={5} style={{ textAlign: 'center' }}>Wanda Montgomery</Typography>
                    <Typography className='text1Mid' style={{ opacity: '0.5', textAlign: 'center' }}>
                        Charted Accountant | 4 Years Experience
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '0.8rem', backgroundImage: 'linear-gradient(to left, #F2F4FB, #EFF2FA, #E8EDF9, #C8D8F1)', borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
                    <LocationOn />
                    <Typography className="text2Mid">Gurugram, Haryana</Typography>
                    <Link style={{ textDecoration: 'none', display: 'flex' }} className="text2Mid">View Profile <ArrowForwardIos sx={{ fontSize: '12px', verticalAlign: 'middle', marginTop: '0.15rem' }} /></Link>
                </Box>
            </Paper>
        </>
    )
}

export default SimiliarCandidateCard;